module.exports = __webpack_public_path__ + "static/media/nobul-logo.6581ed9d.svg";